import { FormattedMessage } from "react-intl";
import GroupManagementIcon from "../../../components/Common/SvgIcons/AdminIcons/GroupManagementIcon";
import AdditionalDetailsIcon from "../../../components/Common/SvgIcons/AdminIcons/UserManagementIcons/AdditionalDetailsIcon";
import UserRolesManagementIcon from "../../../components/Common/SvgIcons/AdminIcons/UserRolesManagementIcon";
import { colors } from "../../stripeColors";
import { distribute } from "./distribute";
import * as yup from "yup";

export const distributionListFormSchema = yup.object().shape({
  Country: yup.string().notRequired().nullable(),
  State: yup.string().notRequired().nullable(),
  City: yup.string().notRequired().nullable(),
  Store: yup
    .array(
      yup.object().shape({
        StoreName: yup.string().notRequired(),
        StoreId: yup.string().notRequired(),
      })
    )
    .notRequired()
    .nullable(),
  Department: yup
    .array(
      yup.object().shape({
        StoreName: yup.string().notRequired(),
        StoreId: yup.string().notRequired(),
      })
    )
    .notRequired()
    .nullable(),
});

export let distributeTo = {
  name: "DistributeTo",
  label: <FormattedMessage id="DISTRIBUTETO_TEXT" />,
  path: (tenantName) => `/${tenantName}/distribute/distributeTo`,
  navLinks: (navigate, tenantName) => [
    {
      key: 1,
      label: distribute.name,
      path: distribute.path(tenantName),
      onClick: () => navigate(`${distribute.path(tenantName)}`),
    },
    {
      key: 2,
      label: distributeTo.label,
      path: `${distributeTo.path(tenantName)}`,
      onClick: () => navigate(`${distributeTo.path(tenantName)}`),
    },
  ],
  tiles: (navigate, tenantName) => [
    {
      key: 1,
      label: <FormattedMessage id="DISTRIBUTE_GROUPTAG" />,
      path: `${distributeTo.path(tenantName)}/group`,
      icon: (fill) => <GroupManagementIcon fill={fill} />,
      color: colors.green,
      onClick: () => navigate(`${distributeTo.path(tenantName)}/group`),
    },
    {
      key: 2,
      label: <FormattedMessage id="DISTRIBUTE_DISTRIBUTELIST" />,
      path: `${distributeTo.path(tenantName)}/distributionList`,
      icon: (fill) => <UserRolesManagementIcon fill={fill} />,
      color: colors.purple,
      onClick: () =>
        navigate(`${distributeTo.path(tenantName)}/distributionList`),
    },
    {
      key: 3,
      label: <FormattedMessage id="DIST_HIST_USERS" />,
      path: `${distributeTo.path(tenantName)}/users`,
      icon: (fill) => <AdditionalDetailsIcon fill={fill} />,
      color: colors.red,
      onClick: () => navigate(`${distributeTo.path(tenantName)}/users`),
    },
  ],
  distributionListForm: {
    name: "Distribution List Form",
    formFields: (formArgs) => [
      {
        key: 1,
        label: <FormattedMessage id="USERMANAGE_COUNTRY" />,
        name: "Country",
        fieldName: "CountryName",
        fieldValue: "Id",
        placeholder: "Select Region / Country",
        type: "select",
        valueArr: formArgs?.countryList,
        onChange: (e) => formArgs?.handleSelectCountry(e),
        loading: formArgs?.getCountryListLoader,
      },
      {
        key: 2,
        label: <FormattedMessage id="USERMANAGE_STATE" />,
        name: "State",
        fieldName: "StateName",
        fieldValue: "Id",
        placeholder: "Select State / Province",
        type: "select",
        valueArr: formArgs?.stateList,
        onChange: (e) => formArgs?.handleSelectState(e),
        loading: formArgs?.getStateListLoader,
      },
      {
        key: 3,
        label: <FormattedMessage id="USERMANAGE_CITY" />,
        name: "City",
        fieldName: "CityName",
        fieldValue: "Id",
        placeholder: "Select City",
        type: "select",
        valueArr: formArgs?.cityList,
        onChange: (e) => formArgs?.handleSelectCity(e),
        loading: formArgs?.getCityListLoader,
      },
      {
        key: 4,
        name: "Store",
        label: <FormattedMessage id="USERMANAGE_STORE" />,
        type: "select",
        fieldName: "StoreName",
        fieldValue: "StoreId",
        placeholder: "Select Location",
        valueArr: formArgs?.storeList,
        onChange: (e) => formArgs?.handleSelectStore(e),
        // height: "5",
        // searchTagsList: formArgs?.storeList,
        // handleTagList: (tagsList) => {
        //   formArgs?.setStoreList(tagsList);
        //   formArgs?.handleStoreList();
        // },
        loading: formArgs?.getWorkOfficeListLoader,
      },
      // {
      //   key: 5,
      //   name: "Category",
      //   label: "User Department",
      //   labelColor: "light",
      //   type: "noSearchTags",
      //   fieldName: "Name",
      //   fieldValue: "CategoryId",
      //   placeholder: "Select",
      //   height: "4",
      //   searchTagsList: formArgs?.userDepartmentList,
      //   // handleTagList: (tagsList) => formArgs?.setUserDepartmentList(tagsList),
      //   isNested: true,
      //   nestFieldName: "SubCategory",
      //   // loading: formArgs.getProductCategoryListLoader,
      //   disabled: false,
      //   isTagCheckBoxVisible: false,
      // },
    ],
  },
};
